import superviseBillApi from '@/api/park/superviseBill';
export default {
  methods: {
    chooseClick(type) {
      this[type]();
    },
    async exportHandler() {
      const tableList = this.tableData.map((item) => item.id);
      console.log(tableList, 'ids');
      let data;
      if (!tableList.length) {
        this.$message.error('没有数据可以导出！');
        return;
      }
      const idList = this.selectionList.map((item) => item.id);
      console.log(this.pageMode, '当前的pageMode');
      if (this.pageMode == 0) {
        console.log('库存查询');
        if (!idList.length) {
          this.isLoading = true;
          data = await this.$axios.post(superviseBillApi.STOCK_QUERY_EXPORT, { ids: tableList });
          this.isLoading = false;
        } else {
          this.isLoading = true;
          data = await this.$axios.post(superviseBillApi.STOCK_QUERY_EXPORT, { ids: idList });
          this.isLoading = false;
        }
        if (data.data.code === 0) {
          window.location.href = data.data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      } else {
        console.log('外部库存查询');
        if (!idList.length) {
          this.isLoading = true;
          data = await this.$axios.post(superviseBillApi.OUT_STOCK_QUERY_EXPORT, {
            ids: tableList,
          });
          this.isLoading = false;
        } else {
          this.isLoading = true;
          data = await this.$axios.post(superviseBillApi.OUT_STOCK_QUERY_EXPORT, { ids: idList });
          console.log(data);
          this.isLoading = false;
        }
        if (data.data.code === 0) {
          window.location.href = data.data.data;
          this.$message.success('导出成功');
        } else {
          this.$message.error('导出失败');
        }
      }
    },
    // 选择一行判断
    checkSelectOneData() {
      if (!this.selectionList.length) {
        this.$message.error('请选择一行操作');
        return false;
      }
      if (this.selectionList.length != 1) {
        this.$message.error('只能选择一行操作');
        return false;
      }
      return true;
    },
  },
};
